import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class IDamagePackage {
  id: string | number;
  creatorId: string | number;
  description: string;
  damageType: string;
  packageId: string | number;
  packagePrice: number;
  damageLocation: string;
  productStatus: string;
  conclusionDate: string;
  invoiceNumber: string;
  productGroup: string | number;
  productLocation: string;
  damageDocumentStatus: string;
  damageImages?: string[];
  productPhotos?: string[];
  packagePhotos?: string[];
  productControlDone?: boolean;
  productControlExplanation?: string;
  receiverName?: string;
  receiverPhoto?: string;
  createdAt: string;
}

export class IDamagePackageListResponse extends IPagination {
  @Type(() => IDamagePackage)
  results: IDamagePackage[];
}

export class IDamagePackageResponse {
  @Type(() => IDamagePackage)
  result: IDamagePackage;
}

export class IDamagePackageQueryDto extends IQueryPaginationDto {
  damageType?: string;
  packageId?: string | number;
  damageLocation?: string;
  productStatus?: string;
  damageDocumentStatus?: string;
  productLocation?: string;
  creatorId?: string | number;
}

export class IPostDamagePackageBodyDto {
  creatorId: string | number;
  description: string;
  damageType: string;
  packageId: string | number;
  packagePrice: number;
  damageLocation: string;
  productStatus: string;
  invoiceNumber: string;
  productGroup: string | number;
  productLocation: string;
  damageDocumentStatus: string;
  damageImages?: string[];
}

export class IPatchDamagePackageBodyDto {
  description?: string;
  damageType?: string;
  packagePrice?: number;
  damageLocation?: string;
  productStatus?: string;
  invoiceNumber?: string;
  productGroup?: string | number;
  productLocation?: string;
  damageDocumentStatus?: string;
}
